"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addNewClause_1 = require("./addNewClause");
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
exports.default = legacy_1.action('initializeInboxRuleEdit')(function initializeInboxRuleEdit(ruleToEditId) {
    if (store_1.default.inboxRulesEditState.conditionalClauseIds.length == 0) {
        addNewClause_1.default('conditional', null, null);
    }
    if (store_1.default.inboxRulesEditState.actionClauseIds.length == 0) {
        addNewClause_1.default('action', null, null);
    }
});
//# sourceMappingURL=initializeInboxRuleEdit.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/initializeInboxRuleEdit.js
// module id = 3076
// module chunks = 2 90